<template>
  <DataTable
    :value="rows"
    :paginator="true"
    :rows="100"
    :rowsPerPageOptions="[25, 50, 100, 200]"
    dataKey="id"
    responsiveLayout="scroll"
    :loading="loading"
  >
    <template #empty>
      <div class="text-center py-4">No associates found</div>
    </template>
    <template #loading>
      <div class="text-center py-4">Loading associates...</div>
    </template>

    <Column field="name" header="Name" :sortable="true" />
    <Column field="email" header="Email" :sortable="true" />
    <Column field="discipline" header="Discipline" :sortable="true" />
    <Column field="organisation_name" header="Organisation" :sortable="true" />
    <Column field="active" header="Status" :sortable="true">
      <template #body="slotProps">
        <Tag
          :value="slotProps.data.active ? 'Active' : 'Inactive'"
          :severity="slotProps.data.active ? 'success' : 'danger'"
        />
      </template>
    </Column>
    <Column field="invitation_status" header="Invitation" :sortable="true">
      <template #body="slotProps">
        <Tag
          :value="slotProps.data.invitation_status || 'n/a'"
          :severity="invitationSeverity(slotProps.data.invitation_status)"
        />
      </template>
    </Column>
    <Column field="last_sign_in_at" header="Last Sign In" :sortable="true">
      <template #body="slotProps">
        {{ formatDate(slotProps.data.last_sign_in_at) }}
      </template>
    </Column>
  </DataTable>
</template>

<script setup>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';

defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false }
});

const invitationSeverity = (status) => {
  switch (status) {
    case 'accepted': return 'success';
    case 'pending':  return 'warning';
    case 'expired':  return 'danger';
    default:         return 'info';
  }
};

const formatDate = (value) => {
  if (!value) return '—';
  try { return new Date(value).toLocaleString(); } catch (e) { return value; }
};
</script>
